@if (showBreadcrumbs) {
<div class="breadcrumbs -fontXSmall">
  @if (items.length > 1) {
  <div class="breadcrumbs -content-container">
    <ul [ngClass]="isApiSpec ? 'breadcrumbs -list api-versions-ul' : 'breadcrumbs -list'">
      @for (item of items; track item; let i = $index; let isLast = $last) {
      <li class="-fontMedium">
        <!-- <icon *ngIf="item.label === 'Home'" [icon]="'home'" [ngClass]="iconColor" class="-sm"> </icon> -->
        @if (!isLast) {
        <a [routerLink]="item.path" (mouseenter)="mouseEnter(i)" (mouseleave)="mouseLeave(i)">
          {{ item.label }}
        </a>
        } @if (isLast) {
        <span>{{ item.label }}</span>
        } @if (!isLast) {
        <div class="breadcrumbs -divider">/</div>
        }
      </li>
      }
    </ul>
    @if (isApiSpec) {
    <div class="d-flex justify-content-end">
      <app-api-versions [pageRoute]="pageRoute"></app-api-versions>
    </div>
    }
  </div>
  }
</div>
}
